import { BaseLogo } from '../../../core/models/entities/BaseLogo'
import { LogoDimensionFormat, LogoDimensions } from './LogoDimensions'

export function LogoSize({ logo, format = "BWWXHYYMM" }: { logo: BaseLogo, format?: LogoDimensionFormat }) {
  return <div className={'pr-1.5 text-xs flex items-center font-medium'}>
    <LogoDimensions logo={logo} format={format} />
  </div>
}